// extracted by mini-css-extract-plugin
module.exports = {"AuthorizationModalSecret":"AuthorizationModalSecret_slq3j"};